import { axios } from "lib/axios";

export const forgotPasswordWithEmail = data => {
  return axios.post("/auth/forgot_password", data);
};
